import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import { emptyArray } from 'ui-components/default-props/empty';
import messages from './messages';
import style from './style.module.less';

const codeToMessageMap = {
  RequiredIdentifier: messages.needsOneOfError,
  SkippedWarning: messages.skippedWarning,
};

const columnNameToMessage = {
  Username: messages.usernameRequired,
  'Address Line 1': messages.addressLine1Required,
  City: messages.cityRequired,
  State: messages.stateRequired,
  'Country Code': messages.countryCodeRequired,
};

const getMessage = (code, context) => {
  if (code === 'RequiredField') {
    return columnNameToMessage[context.columnName];
  }
  return codeToMessageMap[code];
};

const ImportResultsModal = ({ modalFrameworkMethods, logs = emptyArray }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <Modal>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage {...messages.modalTitle} />
      </ModalHeader>
      <ModalBody className={style.body}>
        {logs.map(({ code, context }, index) => {
          const messageDescriptor = getMessage(code, context);
          const values = {
            rowNumber: context.row,
            userName: context.userName,
          };
          return (
            <div key={index} className={style.log}>
              <FormattedMessage {...messageDescriptor} values={values} />
            </div>
          );
        })}
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.closeButton} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ImportResultsModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      code: PropTypes.oneOf(['RequiredField', ...Object.keys(codeToMessageMap)]),
      context: PropTypes.shape({
        row: PropTypes.number,
        userName: PropTypes.string,
        columnName: PropTypes.string,
      }),
    }),
  ),
};

export default ImportResultsModal;
